import { useContext } from 'react';
import { View } from '@shared/components/View';
import { Checkbox } from '@shared/components/checkbox';
import { TextInput } from '@shared/components/textInput';
import { MBTextBody1, MBTextOverlineBold } from '@shared/components/typography';
import { ColorThemeContext } from '@shared/styles';
import { API } from '@shared/types/api';
import { TIME_TRACKER_COMPONENT_GEOLOCATION, useFeatureFlag } from '@shared/util/featureFlags';
import { i18n } from '@shared/util/i18n';
import { useSetComponentField } from '../../hooks';

interface Props {
  component: API.TimeTrackerComponent;
}

export function TimeTrackerExtraSections({ component }: Props) {
  const colors = useContext(ColorThemeContext);
  const isGeolocationFeatureEnabled = useFeatureFlag(TIME_TRACKER_COMPONENT_GEOLOCATION);
  const [startButtonLabel, setStartButtonLabel] = useSetComponentField<
    string,
    API.TimeTrackerComponent
  >(component, 'startButtonLabel');
  const [endButtonLabel, setEndButtonLabel] = useSetComponentField<
    string,
    API.TimeTrackerComponent
  >(component, 'endButtonLabel');
  const [requiresGeolocation, setRequiresGeolocation] = useSetComponentField<
    boolean,
    API.TimeTrackerComponent
  >(component, 'requiresGeolocation');
  const [autoStart, setAutoStart] = useSetComponentField<boolean, API.TimeTrackerComponent>(
    component,
    'autoStart',
  );

  return (
    <>
      <View paddingHorizontal={3} paddingVertical={1}>
        <MBTextOverlineBold color={colors.foregroundInactive}>
          {i18n('workflowTemplate.startTimeTrackerLabel')}
        </MBTextOverlineBold>
        <View paddingTop={1}>
          <TextInput value={startButtonLabel} onChangeText={setStartButtonLabel} />
        </View>
      </View>
      <View paddingHorizontal={3} paddingVertical={1}>
        <MBTextOverlineBold color={colors.foregroundInactive}>
          {i18n('workflowTemplate.endTimeTrackerLabel')}
        </MBTextOverlineBold>
        <View paddingTop={1}>
          <TextInput value={endButtonLabel} onChangeText={setEndButtonLabel} />
        </View>
      </View>
      <View paddingHorizontal={3} paddingVertical={1}>
        <MBTextOverlineBold color={colors.foregroundInactive}>
          {i18n('workflowTemplate.autoStartLabel')}
        </MBTextOverlineBold>
        <View paddingTop={1} row centerVertically>
          <Checkbox checked={autoStart} onChange={setAutoStart} />
          <MBTextBody1 align="left"> {i18n('workflowTemplate.autoStartLabel')}</MBTextBody1>
        </View>
      </View>
      {isGeolocationFeatureEnabled && (
        <View paddingHorizontal={3} paddingVertical={1}>
          <MBTextOverlineBold color={colors.foregroundInactive}>
            {i18n('workflowTemplate.requiresGeolocationLabel')}
          </MBTextOverlineBold>
          <View paddingTop={1} row centerVertically>
            <Checkbox checked={requiresGeolocation} onChange={setRequiresGeolocation} />
            <MBTextBody1 align="left"> {i18n('workflowTemplate.require')}</MBTextBody1>
          </View>
        </View>
      )}
    </>
  );
}
